import React from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import { BookBookmark, Warning } from "@phosphor-icons/react";

const items = [
  { ref: "21 CFR 101.9", title: "Nutrition Labeling of Food", body: "Mandates the Nutrition Facts panel format, serving size, and nutrients required. Values must be rounded per specific rules (calories to nearest 5 under 50 kcal / nearest 10 above; fat to 0.5g under 5g / 1g above; sodium to 5mg up to 140mg / 10mg above)." },
  { ref: "21 CFR 101.4", title: "Ingredient Declaration", body: "Ingredients must be listed in descending order of predominance by weight using common or usual names. Sub-ingredients appear in parentheses directly after the ingredient that contains them." },
  { ref: "FALCPA + FASTER Act", title: "Major Food Allergens (9)", body: "Milk, eggs, fish, crustacean shellfish, tree nuts, peanuts, wheat, soybeans, and (since Jan 1, 2023) sesame. Declare via a separate 'Contains:' statement adjacent to the ingredient list, or via the ingredient list itself if common names are used." },
  { ref: "21 CFR 101.22", title: "Natural Flavor Definition", body: "A natural flavor is the essential oil, oleoresin, essence or extractive, protein hydrolysate, distillate, or any product of roasting, heating or enzymolysis of a spice, fruit, vegetable, edible yeast, herb, bark, bud, root, leaf, meat, seafood, poultry, eggs, dairy products, or fermentation products thereof, whose significant function is flavoring rather than nutritional." },
  { ref: "21 CFR 101.13", title: "Nutrient Content Claims", body: "Claims like 'low fat', 'high in fiber', 'good source of' are tightly regulated. Alaine's Bench's AI Compliance Assistant can review proposed claims against your nutrient profile." },
  { ref: "21 CFR 101.9(c)(6)(iii)", title: "Added Sugars", body: "Must be declared separately from Total Sugars. Includes sugars added during processing, syrups and honey, and sugars from concentrated fruit juices." },
];

export default function Regulations() {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="text-xs uppercase tracking-[0.2em] text-stone-500">Reference</div>
        <h1 className="text-4xl font-bold tracking-tight">FDA regulations quick-reference</h1>
        <p className="text-stone-600 mt-2 max-w-2xl">A distilled summary of the key rules Alaine's Bench enforces. Always verify against the live CFR before commercial launch.</p>

        <div className="rounded-lg border border-amber-300 bg-amber-100 text-amber-900 p-4 mt-6 flex gap-3">
          <Warning size={22} weight="fill" className="shrink-0" />
          <div className="text-sm">This summary is informational only and not a substitute for legal advice. Consult a qualified food-law attorney before bringing a product to market.</div>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mt-6">
          {items.map((it) => (
            <Card key={it.ref} className="p-5 border-stone-200">
              <div className="flex items-center gap-2">
                <BookBookmark size={18} weight="duotone" className="text-emerald-800" />
                <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-800 font-bold">{it.ref}</div>
              </div>
              <div className="font-semibold mt-1">{it.title}</div>
              <div className="text-sm text-stone-600 mt-2 leading-relaxed">{it.body}</div>
            </Card>
          ))}
        </div>
      </div>
    </Layout>
  );
}
